<template>
  <div class="widget">
    <div class="widget__head">
      <h3 class="widget__title">
        <slot name="heading" />
      </h3>
    </div>
    <div v-loading="loading" class="widget__body">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>